$(document).ready(function() {
    
    // Homepage video
    // when video is ready to load, fade it in
    $('.homepage-banner__video').on('canplay', function() {
        $('.homepage-banner__video').animate({'opacity': 1}, 1000);
    });
    
});